import React, { useContext } from 'react';
import { Container } from '../../shared/Container';
import { Logo } from '../../../icons/components';
import { FormContext } from '../../../store/surplus/SurPlusContext';

export const Header = () => {
	const { consumer } = useContext(FormContext);
	return (
		<header className="c-header">
			<Container extraClass="header__container">
				<a className="header__logo" href="https://www.hypotheker.nl/" target={(consumer.status) ? '_blank' : '_self'}>
					<Logo height={40} width={320} />
				</a>
			</Container>
		</header>
	);
};
